import React from "react";
import Hero from "../components/landingPageComponents/Hero";
import Stats from "../components/landingPageComponents/Stats";
import Testimonials from "../components/landingPageComponents/Testimonials";
import OurTeam from "../components/landingPageComponents/OurTeam";
import Cta from "../components/landingPageComponents/Cta";
import ContactUs from "../components/commonComponents/contact";
import SEO from "../components/SEO";

function LandingPage() {
  return (
    <>
      <SEO
        title="Home - Aastha Computers | Most Trusted institute in Bikaner"
        description="Welcome to Aastha Computes, Bikaner — the leading computer coaching institute. Offering comprehensive computer courses for all ages with expert instructors and modern facilities."
        pagePath="/"
      />
      <Hero />
      <Stats />
      <Testimonials />
      <OurTeam />
      <Cta />
      <ContactUs />
    </>
  );
}

export default LandingPage;
